import { Link as ChakraLink, LinkOverlay } from '@chakra-ui/react';
import { createLink, LinkComponent } from '@tanstack/react-router';

import { BasicLinkComponent } from '#features/routing/components/Link';

type LinkProps = {
  overlay?: boolean;
} & React.ComponentProps<typeof BasicLinkComponent> &
  Omit<React.ComponentPropsWithoutRef<typeof ChakraLink>, 'href' | 'overlay'>;

export const BaseLink = ({ children, overlay = false, inNewTab, ref, ...props }: LinkProps) => {
  const LinkComponent = overlay ? LinkOverlay : ChakraLink;

  return (
    <LinkComponent ref={ref} asChild {...props}>
      <BasicLinkComponent inNewTab={inNewTab}>{children}</BasicLinkComponent>
    </LinkComponent>
  );
};

const CreatedLink = createLink(BaseLink);

export const Link: LinkComponent<typeof CreatedLink> = (props) => {
  return <CreatedLink {...props} />;
};
